// extracted by mini-css-extract-plugin
module.exports = {"form":"NewPostForm_form__1Z7cI","input":"NewPostForm_input__1OeCf","button":"NewPostForm_button__1jJob"};